export const coachEnum = {
    'SUPER_COACH': 'SUPER_COACH',
    'COACH': 'COACH'
};
